import { motion } from "framer-motion";
import { IMAGES } from "@/data";

const chapters = [
  {
    num: "01",
    title: "The Fire",
    text: "Everything starts over charcoal. No shortcuts, no gas grills pretending. You taste the smoke in every bite.",
    img: IMAGES.skewers,
    alt: "Skewers grilling over charcoal",
  },
  {
    num: "02",
    title: "The Dough",
    text: "Pizza dough made fresh daily, stretched by hand and fired hard until the crust blisters and chars just right.",
    img: IMAGES.oven,
    alt: "Wood fired pizza oven",
  },
  {
    num: "03",
    title: "The Night",
    text: "Mildura doesn't sleep, and neither do we. Firing till 1AM most nights, 3AM on weekends. The late crowd knows.",
    img: IMAGES.shopNight,
    alt: "Avanti Pizza & Kebab lit up at night",
  },
];

export default function Manifesto() {
  return (
    <section id="shop" className="border-y border-zinc-800 bg-coal-800" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 py-28 lg:py-40">
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-ember mb-4">Why Avanti</p>
        <h2 className="font-display text-6xl sm:text-7xl leading-none uppercase mb-20 text-gold-shine" data-testid="manifesto-heading">
          Three things<br />we live by
        </h2>
        <div className="space-y-24">
          {chapters.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: "circOut" }}
              className={`grid md:grid-cols-2 gap-10 items-center ${i % 2 ? "md:[&>*:first-child]:order-2" : ""}`}
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <div className="relative">
                <span className="absolute -top-14 -left-2 font-mono text-8xl text-stroke-ember select-none" aria-hidden="true">
                  {c.num}
                </span>
                <div className="overflow-hidden border border-zinc-800">
                  <motion.img
                    src={c.img}
                    alt={c.alt}
                    className="w-full h-72 sm:h-96 object-cover"
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.6 }}
                    loading="lazy"
                  />
                </div>
              </div>
              <div>
                <span className="font-mono text-xs tracking-[0.3em] text-ember">{c.num} /</span>
                <h3 className="font-display text-5xl sm:text-6xl uppercase mt-2 mb-6">{c.title}</h3>
                <p className="text-zinc-400 text-base leading-relaxed max-w-md">{c.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
